import {
  addProjection,
  fromLonLat,
  get,
  toLonLat,
  transformExtent,
} from 'ol/proj'
import Projection from 'ol/proj/Projection'
import { register } from 'ol/proj/proj4'
import proj4 from 'proj4'
import { PROJ_DEFINITIONS } from '../../constants'

const registeredProjections = new Map()

export const defaultProjection = 'EPSG:3857'

export const registerProjection = projectionName => {
  if (registeredProjections.has(projectionName)) {
    return
  }

  if (
    Object.keys(PROJ_DEFINITIONS).includes(projectionName) &&
    'definition' in PROJ_DEFINITIONS[projectionName]
  ) {
    proj4.defs(projectionName, PROJ_DEFINITIONS[projectionName].definition)

    register(proj4)

    const projection = {
      code: projectionName,
    }

    if (
      'extent' in PROJ_DEFINITIONS[projectionName] &&
      Array.isArray(PROJ_DEFINITIONS[projectionName].extent) &&
      PROJ_DEFINITIONS[projectionName].extent.length === 4
    ) {
      projection.extent = PROJ_DEFINITIONS[projectionName].extent
    }

    if ('units' in PROJ_DEFINITIONS[projectionName]) {
      projection.units = PROJ_DEFINITIONS[projectionName].units
    }

    addProjection(new Projection(projection))
    registeredProjections.set(projectionName, true)
  }
}

export const getProjection = get

export const transform = (
  type,
  input,
  proj1 = 'EPSG:4326',
  proj2 = 'EPSG:4326',
) => {
  let output

  if (proj1 === proj2) {
    return input
  }

  const proj1Exists = getProjection(proj1)
  if (!proj1Exists) {
    registerProjection(proj1)
  }

  const proj2Exists = getProjection(proj2)
  if (!proj2Exists) {
    registerProjection(proj2)
  }

  switch (type) {
    case 'fromLonLat':
      output = fromLonLat(input, proj1)
      break
    case 'toLonLat':
      output = toLonLat(input, proj1)
      break
    case 'extent':
      output = transformExtent(input, proj1, proj2)
      break
  }

  return output || input
}
